import { render, staticRenderFns } from "./whaleLoginComponent.vue?vue&type=template&id=2c55ad5f&"
import script from "./whaleLoginComponent.vue?vue&type=script&lang=js&"
export * from "./whaleLoginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports